module.exports = __webpack_public_path__ + "static/img/banner.604e60d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_12/banner.jpg
// module id = 6TA8
// module chunks = 0